import { get, startCase, uniqueId } from "lodash";
import {
  ILayoutSettings,
  PageSectionCategory,
} from "@/Apps/Pages/Sections/WebLayouts/types";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { combineData, lorem } from "../../utils";
import { default as defaultData } from "./data.json";
import { style } from "./style";
import {
  getImagePlaceholder,
  ImagePlaceholderTypes,
  getVideoPlaceholder,
  VideoPlaceholderTypes,
} from "../../Placeholders";
import theme from "../../theme";
import { NavigationLayouts } from "../types";
import {
  LinkDisplayTypes,
  LinkLayoutStyles,
} from "@/Apps/Pages/WebComponents/v2/Navigation/types";
// import { IconTypes } from "@/Apps/Pages/WebComponents/v2/Icon";
import { ButtonPresets } from "@/Apps/Pages/WebComponents/v2/Button/types";

const content = combineData(defaultData);

const settings: ILayoutSettings = {
  label: NavigationLayouts.FOUR,
  layout: NavigationLayouts.FOUR,
  previewImage:
    "https://sandcastleassets.s3.amazonaws.com/blocks/navigation/Navigation04.png",
  loadFromExt: true,
  loadFromExtSettings: {
    pageId: "ckkzm1kez2ie007803ieamizj",
    itemId: "yqz67bolu2s",
  },
  default: {
    type: ComponentTypes.SECTION,
    label: PageSectionCategory.FOOTER,
    bodyOnly: true,
    canHaveChildren: false,
    properties: {
      ...style.SECTION,
      ...style.SECTION_INNER,
    },
    children: [
      {
        type: ComponentTypes.COLUMNS,
        canHaveChildren: false,
        properties: {
          width: "100%",
        },
        children: [
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((2 * 100) / 12),
            properties: {
              height: "100%",
              mobile: {
                desktop: {
                  padding: 20,
                },
                smartphone: {
                  padding: 5,
                },
              },
              minHeight: 20,
            },
            children: [
              getImagePlaceholder({
                type: ImagePlaceholderTypes.NONE,
                src: theme.logoIcon,
                style: {
                  width: 75,
                  display: "inline-block",
                  mobile: {
                    desktop: {
                      textAlign: "left",
                    },
                    smartphone: {
                      textAlign: "center",
                    },
                  },
                },
              }),
            ],
          },
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((6 * 100) / 12),
            properties: {
              height: "100%",
              mobile: {
                desktop: {
                  padding: 20,
                },
                smartphone: {
                  padding: 5,
                },
              },
              minHeight: 20,
            },
            children: [
              {
                type: ComponentTypes.NAVIGATION,
                canHaveChildren: false,
                linkStyle: style.NAVIGATION.linkStyle,
                layoutStyle: LinkLayoutStyles.HORIZONTAL,
                properties: {
                  padding: 20,
                  textAlign: "center",
                  display: "inline-block",
                },
                data: [
                  {
                    id: uniqueId(),
                    caption: "Home",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                  {
                    id: uniqueId(),
                    caption: "Features",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                  {
                    id: uniqueId(),
                    caption: "Blog",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                  {
                    id: uniqueId(),
                    caption: "About Us",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                  {
                    id: uniqueId(),
                    caption: "Contact Us",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                ],
              },
            ],
          },
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((4 * 100) / 12),
            properties: {
              height: "100%",
              mobile: {
                desktop: {
                  padding: 20,
                },
                smartphone: {
                  padding: 10,
                },
              },
              minHeight: 20,
            },
            children: [
              {
                type: ComponentTypes.NAVIGATION,
                canHaveChildren: false,
                linkStyle: style.NAVIGATION.linkStyle,
                layoutStyle: LinkLayoutStyles.HORIZONTAL,
                properties: {
                  padding: 20,
                  textAlign: "center",
                  display: "inline-block",
                },
                data: [
                  {
                    id: uniqueId(),
                    caption: "Learn More",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                  {
                    id: uniqueId(),
                    caption: "Sign Up",
                    preset: ButtonPresets.BUTTON02,
                    linkDisplayType: LinkDisplayTypes.BUTTON,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default settings;
